import { useEffect } from "react";
import { Lines, Reveal } from "../components/site/Motion";
import NetworkMap from "../components/site/NetworkMap";

export default function NetworkPage() {
  useEffect(() => {
    document.title = "Rete SWAPA — Trova il centro più vicino | SWAPA";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", "Trova il centro SWAPA più vicino sulla mappa: test drive, vendita e assistenza nella rete ufficiale italiana SWAPA.");
  }, []);

  return (
    <div data-testid="network-page" className="bg-ink pb-28 pt-32 sm:pt-40">
      <div className="mx-auto max-w-[1600px] px-5 sm:px-10">
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-swapa-yellow">SWAPA Network</p>
        <h1 className="mt-6 font-display font-black uppercase leading-[0.9] tracking-tighter">
          <Lines animate="load" lines={["Find SWAPA."]} className="text-5xl text-white sm:text-7xl lg:text-8xl" />
        </h1>
        <Reveal delay={0.25}>
          <p className="mb-14 mt-6 max-w-xl text-base leading-relaxed text-zinc-400">
            Test drive, vendita e service. Ogni centro SWAPA può coprire uno o più ruoli:
            filtra la mappa per trovare quello che serve a te.
          </p>
        </Reveal>
        <NetworkMap />
      </div>
    </div>
  );
}
